import { connect } from "react-redux";
import PaymentCodeCreate from "./PaymentCodeCreate";
import { actions } from "./actions";

export default connect(
  state => ({ paymentCodes: state.paymentCodes }),
  actions
)(PaymentCodeCreate);
